import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';

/* eslint-disable @typescript-eslint/naming-convention */
export const SaveTwigTemplateDialogVariableMap: Map<StyleTypesApiEnum, any[]> = new Map<StyleTypesApiEnum, any[]>([
    [StyleTypesApiEnum.TEXT, [
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.text.textLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.text.textTooltip'
        }
    ]],
    [StyleTypesApiEnum.TITLE, [
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.title.textLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.title.textTooltip'
        }
    ]],
    [StyleTypesApiEnum.DATE, [
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.title.dateLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.title.dateTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.title.formatLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.title.formatTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.title.viewInBrowserUrlLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.title.viewInBrowserUrlTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.title.showViewInBrowserLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.title.showViewInBrowserTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.title.viewInBrowserLabelLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.title.viewInBrowserLabelTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.title.showDateLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.title.showDateTooltip'
        }
    ]],
    [StyleTypesApiEnum.CURATED_MENTION_LIST, [
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.titleLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.titleTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.mentionsLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.mentionsTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.outletNameLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.outletNameTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.contactNameLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.contactNameTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.mentionTitleLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.mentionTitleTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.urlLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.urlTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.viewerUrlLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.viewerUrlTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.mediaTypeLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.mediaTypeTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.sentimentLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.sentimentTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.audienceReachLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.audienceReachTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.adValueUsdLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.adValueUsdTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.publishedDateLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.publishedDateTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.harvestedDateLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.harvestedDateTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.summaryLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.summaryTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.bodyLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.bodyTooltip'
        },
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.mention.noteLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.mention.noteTooltip'
        }
    ]],
    [StyleTypesApiEnum.ANALYSIS, [
        {
            label: 'Styles.saveTwigTemplateDialog.documentation.analysis.textLabel',
            tooltip: 'Styles.saveTwigTemplateDialog.documentation.analysis.textTooltip'
        }
    ]],

]
);
